module.exports = __webpack_public_path__ + "img/29400.72e9a868.jpg";